import React from 'react';
import {DmsTab} from 'Components';
import {hashHistory} from 'react-router';
import {Form, Input, Select, Button, Row, Col,message} from 'antd';
import {saveOrUpdate, globalVarDetail} from '../../service/globalVar';
const Option = Select.Option;
const FormItem = Form.Item;
const {TextArea} = Input;
import {showSpin,hideSpin} from 'Utils';
import {nameValidator,checkValue} from '../../utils/regexp.js';


class GlobalVarAdd extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			opts: ['新建变量'],
			detail: {},
			editFlag:false
		}
		this.checkSkey=this.checkSkey.bind(this);
	}
	
	componentDidMount() {
		//console.log(this.props.location.query.index);
		if (this.props.location.query.globalId) {
			this.setState({
				opts: ['编辑变量']
			})
			//根据传过来的index，获取特定的值，并赋值给detail
			var globalObj = {};
			globalObj.id = parseInt(this.props.location.query.globalId, 0);
			globalVarDetail(globalObj).then(result => {
				if(result.status){
					this.setState({
						detail: result.data,
						editFlag:true
					})
				}else{
					message.error(result.message);
				}
			})
		}
	}
	
	cancelHandle() {
		hashHistory.goBack();
	}
	
	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;
		
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			if (data.active === '1') {
				data.active = 1;
			} else {
				data.active = 0;
			}
			if (this.props.location.query.globalId) {
				data.id=this.state.detail.id;
			}

      showSpin();
			saveOrUpdate(data).then(result=>{
				hideSpin();
				if(result.status){
					message.success(result.message);
					hashHistory.goBack();
				}else{
					message.error(result.message);
				}
			})
		})
		
	}
	
	
	//skey正则
	checkSkey(rule, value, callback) {
		const vaReg = /^(?!_)(?!.*?_$)\w{1,50}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('请输入1-50位的数字、字母或下划线,但不可用下划线开头和结尾');
			}
			callback();
		}
		callback();
	}
	
	render() {
		const {opts, detail} = this.state;
		const {getFieldDecorator} = this.props.form;
		return <div className='dms-body'>
				<DmsTab options={opts} defaultKey={0}>
					<Button onClick={this.cancelHandle.bind(this)}>取消</Button>
					<Button type='primary' onClick={this.submitHandle.bind(this)}>保存</Button>
				</DmsTab>
				<div className="dms-table-box" style={{backgroundColor: "#fff"}}>
					<Form layout="horizontal">
						<Row gutter={16}>
							<Col className="gutter-row" span={12}>
								<FormItem label="变量Key" hasFeedback>
									{getFieldDecorator('sKey', {
										initialValue: (detail !== null && detail.sKey) ? detail.sKey : '',
										rules: [
											{
												required: true,
												message: '请输入变量Key'
											},
											{
												validator: this.checkSkey
											}
										],
									})(<Input disabled={this.state.editFlag} placeholder="请输入变量Key，保存后不可修改"/>)}
								</FormItem>
							</Col>
							<Col className="gutter-row" span={12}>
								<FormItem label="变量名称" hasFeedback>
									{getFieldDecorator('name', {
										initialValue: (detail !== null && detail.name) ? detail.name : '',
										rules: [
											{
												required: true,
												message: '请输入变量名称'
											},
											{
												validator: nameValidator
											}
										],
									})(<Input placeholder="请输入变量名称"/>)}
								</FormItem>
							</Col>
						</Row>
						
						<Row>
							<Col className="gutter-row" span={12}>
								<FormItem label="变量Value" hasFeedback>
									{getFieldDecorator('value', {
										initialValue: (detail !== null && detail.value) ? detail.value : '',
										rules: [
											{
												required: true,
												message: '请输入变量值'
											},
											{
												validator: checkValue
											}
										],
									})(<Input placeholder="请输入变量值"/>)}
								</FormItem>
							</Col>
						</Row>
						
						<Row>
							<FormItem label="描述">
								{getFieldDecorator('description', {
									initialValue: (detail !== null && detail.description) ? detail.description : ''
								})(<TextArea rows={4}/>)}
							</FormItem>
						</Row>
						
						<Row gutter={16}>
							<Col className="gutter-row" span={12}>
								<FormItem label="状态">
									{getFieldDecorator('active', {
										initialValue: (detail !== null && detail.active === 0) ? '0' : '1',
										rules: [
											{
												required: true,
												message: '请选择状态'
											},
										]
									})(<Select>
										<Option value='1'>启用</Option>
										<Option value='0'>禁用</Option>
									</Select>)}
								</FormItem>
							</Col>
						</Row>
					
					</Form>
				</div>
		</div>
	}
}
export default Form.create()(GlobalVarAdd)


// WEBPACK FOOTER //
// ./src/routes/globalVar/add.js